import { render, staticRenderFns } from "./T1TabOffersPlaceholder.vue?vue&type=template&id=01ec7965&scoped=true&"
var script = {}
import style0 from "./T1TabOffersPlaceholder.vue?vue&type=style&index=0&id=01ec7965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec7965",
  null
  
)

export default component.exports